import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaGift } from 'react-icons/fa';

interface RewardFormHeaderProps {
  isEditMode: boolean;
  animateIn: boolean;
}

export const RewardFormHeader: React.FC<RewardFormHeaderProps> = ({ isEditMode, animateIn }) => {
  const navigate = useNavigate();

  return (
    <div className={`mb-8 transition-all duration-700 ease-out transform ${animateIn ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
      <button
        onClick={() => navigate('/rewards')}
        type="button"
        className="flex items-center text-indigo-600 hover:text-indigo-800 font-medium mb-6 transition-colors group"
      >
        <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center mr-3 group-hover:bg-indigo-200 transition-colors">
          <FaArrowLeft className="text-sm" />
        </div>
        Back to Rewards
      </button>
      
      <div className="bg-white rounded-2xl shadow-sm p-8 border border-gray-100">
        <div className="flex items-center gap-5">
          <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-md">
            <FaGift className="text-white text-2xl" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">{isEditMode ? 'Edit Reward' : 'Create New Reward'}</h1>
            <p className="text-gray-500 mt-1">{isEditMode ? 'Update the reward details below.' : 'Configure a new reward offering for users to exchange with Karma.'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
